<template>
    <div class="help-block text-danger text-sm" v-if="hasErrors">
        <div v-for="(error, key) in errors" :key="key">{{ error }}</div>
    </div>
</template>

<script>
export default {
    name: "InputError",
    props: {
        errors: Array
    },

    computed: {
        hasErrors() {
            return this.errors && this.errors.length;
        }
    }
}
</script>

<style scoped>

</style>